const MIN_SEARCH_TERM_LENGTH = 3;

export const shouldSearchPersonResults = (searchTerm: string): boolean => {
  return searchTerm.length >= MIN_SEARCH_TERM_LENGTH;
};
